import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import { syncKeys } from './queries';
import type { SyncRun } from './types';

export function useTriggerSync() {
  const qc = useQueryClient();
  return useMutation({
    // Geen tenantId of applicationId in de body: de API leidt beide af uit de
    // ingelogde gebruiker en de X-Application-Id header (die client.ts al zet).
    mutationFn: (): Promise<SyncRun> =>
      apiFetch<SyncRun>('/sync', {
        method: 'POST',
        body: JSON.stringify({}),
      }),
    onSuccess: (run) => {
      qc.setQueryData(syncKeys.latest(), run);
    },
  });
}
